/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Member API
 * API for Catch Member Backend
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActionPlanInterventionsListDto,
  CommunicationPreferenceDto,
  CommunicationPreferencesResponse,
  ConditionDto,
  HealthControllerCheck200,
  HealthControllerCheck503,
  MeResponse,
  PostCompletedActionPlanInterventionDto,
  ProblemDetail,
  PutActionPlanDto,
  ResourceDto,
  RiskAnalysisDto,
  RiskProcessingStatusResponseDto,
  ScreeningAnswerDto,
  ScreeningDto,
  SuccessResponse,
  UpdateCommunicationPreferencesSuccessResponse,
  UpdateProfileDto,
  UpdateProfileResponse,
  UpdateUserLevelDto,
  UserAssessmentQuestionnaireControllerPutQuestionAnswerBody,
  UserFeatureFlagDto,
  UserQuestionnaireDto,
  UserRiskDto,
  UserRiskFactorToCancersImpactDto,
  UserRiskFactorsPerCancerDto,
  UserRiskTrendDto,
  UserScreeningQuestionnaireControllerPutSurveyItemAnswerBody,
  UserScreeningsDto
} from '.././model';

import { customFetcher } from '../../../client/customFetcher';




export const appControllerGetHello = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<void>(
      {url: `/`, method: 'GET', signal
    },
      );
    }
  



export const getAppControllerGetHelloQueryKey = () => {
    return [
    `/`
    ] as const;
    }

    
export const getAppControllerGetHelloQueryOptions = <TData = Awaited<ReturnType<typeof appControllerGetHello>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppControllerGetHelloQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerGetHello>>> = ({ signal }) => appControllerGetHello(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppControllerGetHelloQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerGetHello>>>
export type AppControllerGetHelloQueryError = unknown


export function useAppControllerGetHello<TData = Awaited<ReturnType<typeof appControllerGetHello>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerGetHello>>,
          TError,
          Awaited<ReturnType<typeof appControllerGetHello>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppControllerGetHello<TData = Awaited<ReturnType<typeof appControllerGetHello>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerGetHello>>,
          TError,
          Awaited<ReturnType<typeof appControllerGetHello>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppControllerGetHello<TData = Awaited<ReturnType<typeof appControllerGetHello>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppControllerGetHello<TData = Awaited<ReturnType<typeof appControllerGetHello>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppControllerGetHelloQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const actionPlansControllerGetAvailableInterventions = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<ActionPlanInterventionsListDto>(
      {url: `/action-plans/available-interventions`, method: 'GET', signal
    },
      );
    }
  



export const getActionPlansControllerGetAvailableInterventionsQueryKey = () => {
    return [
    `/action-plans/available-interventions`
    ] as const;
    }

    
export const getActionPlansControllerGetAvailableInterventionsQueryOptions = <TData = Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActionPlansControllerGetAvailableInterventionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>> = ({ signal }) => actionPlansControllerGetAvailableInterventions(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActionPlansControllerGetAvailableInterventionsQueryResult = NonNullable<Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>>
export type ActionPlansControllerGetAvailableInterventionsQueryError = unknown


export function useActionPlansControllerGetAvailableInterventions<TData = Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>,
          TError,
          Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActionPlansControllerGetAvailableInterventions<TData = Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>,
          TError,
          Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActionPlansControllerGetAvailableInterventions<TData = Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActionPlansControllerGetAvailableInterventions<TData = Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionPlansControllerGetAvailableInterventions>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActionPlansControllerGetAvailableInterventionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const actionPlansControllerGetActionPlan = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<ActionPlanInterventionsListDto>(
      {url: `/action-plans/current`, method: 'GET', signal
    },
      );
    }
  



export const getActionPlansControllerGetActionPlanQueryKey = () => {
    return [
    `/action-plans/current`
    ] as const;
    }

    
export const getActionPlansControllerGetActionPlanQueryOptions = <TData = Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActionPlansControllerGetActionPlanQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>> = ({ signal }) => actionPlansControllerGetActionPlan(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActionPlansControllerGetActionPlanQueryResult = NonNullable<Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>>
export type ActionPlansControllerGetActionPlanQueryError = unknown


export function useActionPlansControllerGetActionPlan<TData = Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>,
          TError,
          Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActionPlansControllerGetActionPlan<TData = Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>,
          TError,
          Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActionPlansControllerGetActionPlan<TData = Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActionPlansControllerGetActionPlan<TData = Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof actionPlansControllerGetActionPlan>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActionPlansControllerGetActionPlanQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const actionPlansControllerPutActionPlan = (
    putActionPlanDto: PutActionPlanDto,
 ) => {
      
      
      return customFetcher<ActionPlanInterventionsListDto>(
      {url: `/action-plans/current`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putActionPlanDto
    },
      );
    }
  


export const getActionPlansControllerPutActionPlanMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof actionPlansControllerPutActionPlan>>, TError,{data: PutActionPlanDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof actionPlansControllerPutActionPlan>>, TError,{data: PutActionPlanDto}, TContext> => {

const mutationKey = ['actionPlansControllerPutActionPlan'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof actionPlansControllerPutActionPlan>>, {data: PutActionPlanDto}> = (props) => {
          const {data} = props ?? {};

          return  actionPlansControllerPutActionPlan(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActionPlansControllerPutActionPlanMutationResult = NonNullable<Awaited<ReturnType<typeof actionPlansControllerPutActionPlan>>>
    export type ActionPlansControllerPutActionPlanMutationBody = PutActionPlanDto
    export type ActionPlansControllerPutActionPlanMutationError = unknown

    export const useActionPlansControllerPutActionPlan = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof actionPlansControllerPutActionPlan>>, TError,{data: PutActionPlanDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof actionPlansControllerPutActionPlan>>,
        TError,
        {data: PutActionPlanDto},
        TContext
      > => {

      const mutationOptions = getActionPlansControllerPutActionPlanMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const actionPlansControllerPostCompletedActionPlanIntervention = (
    postCompletedActionPlanInterventionDto: PostCompletedActionPlanInterventionDto,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<void>(
      {url: `/action-plans/current/completed-interventions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCompletedActionPlanInterventionDto, signal
    },
      );
    }
  


export const getActionPlansControllerPostCompletedActionPlanInterventionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof actionPlansControllerPostCompletedActionPlanIntervention>>, TError,{data: PostCompletedActionPlanInterventionDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof actionPlansControllerPostCompletedActionPlanIntervention>>, TError,{data: PostCompletedActionPlanInterventionDto}, TContext> => {

const mutationKey = ['actionPlansControllerPostCompletedActionPlanIntervention'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof actionPlansControllerPostCompletedActionPlanIntervention>>, {data: PostCompletedActionPlanInterventionDto}> = (props) => {
          const {data} = props ?? {};

          return  actionPlansControllerPostCompletedActionPlanIntervention(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActionPlansControllerPostCompletedActionPlanInterventionMutationResult = NonNullable<Awaited<ReturnType<typeof actionPlansControllerPostCompletedActionPlanIntervention>>>
    export type ActionPlansControllerPostCompletedActionPlanInterventionMutationBody = PostCompletedActionPlanInterventionDto
    export type ActionPlansControllerPostCompletedActionPlanInterventionMutationError = unknown

    export const useActionPlansControllerPostCompletedActionPlanIntervention = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof actionPlansControllerPostCompletedActionPlanIntervention>>, TError,{data: PostCompletedActionPlanInterventionDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof actionPlansControllerPostCompletedActionPlanIntervention>>,
        TError,
        {data: PostCompletedActionPlanInterventionDto},
        TContext
      > => {

      const mutationOptions = getActionPlansControllerPostCompletedActionPlanInterventionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const cancersByRiskFactorControllerGetUserRisk = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<UserRiskFactorToCancersImpactDto>(
      {url: `/cancers-by-risk-factor`, method: 'GET', signal
    },
      );
    }
  



export const getCancersByRiskFactorControllerGetUserRiskQueryKey = () => {
    return [
    `/cancers-by-risk-factor`
    ] as const;
    }

    
export const getCancersByRiskFactorControllerGetUserRiskQueryOptions = <TData = Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCancersByRiskFactorControllerGetUserRiskQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>> = ({ signal }) => cancersByRiskFactorControllerGetUserRisk(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CancersByRiskFactorControllerGetUserRiskQueryResult = NonNullable<Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>>
export type CancersByRiskFactorControllerGetUserRiskQueryError = unknown


export function useCancersByRiskFactorControllerGetUserRisk<TData = Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>,
          TError,
          Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCancersByRiskFactorControllerGetUserRisk<TData = Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>,
          TError,
          Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCancersByRiskFactorControllerGetUserRisk<TData = Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCancersByRiskFactorControllerGetUserRisk<TData = Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cancersByRiskFactorControllerGetUserRisk>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCancersByRiskFactorControllerGetUserRiskQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const communicationPreferencesControllerGetCommunicationPreferences = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<CommunicationPreferencesResponse>(
      {url: `/communication-preferences`, method: 'GET', signal
    },
      );
    }
  



export const getCommunicationPreferencesControllerGetCommunicationPreferencesQueryKey = () => {
    return [
    `/communication-preferences`
    ] as const;
    }

    
export const getCommunicationPreferencesControllerGetCommunicationPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>, TError = ProblemDetail>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommunicationPreferencesControllerGetCommunicationPreferencesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>> = ({ signal }) => communicationPreferencesControllerGetCommunicationPreferences(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CommunicationPreferencesControllerGetCommunicationPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>>
export type CommunicationPreferencesControllerGetCommunicationPreferencesQueryError = ProblemDetail


export function useCommunicationPreferencesControllerGetCommunicationPreferences<TData = Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>, TError = ProblemDetail>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>,
          TError,
          Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommunicationPreferencesControllerGetCommunicationPreferences<TData = Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>,
          TError,
          Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommunicationPreferencesControllerGetCommunicationPreferences<TData = Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCommunicationPreferencesControllerGetCommunicationPreferences<TData = Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationPreferencesControllerGetCommunicationPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommunicationPreferencesControllerGetCommunicationPreferencesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const communicationPreferencesControllerUpdateCommunicationPreferences = (
    communicationPreferenceDto: CommunicationPreferenceDto[],
 ) => {
      
      
      return customFetcher<UpdateCommunicationPreferencesSuccessResponse>(
      {url: `/communication-preferences`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: communicationPreferenceDto
    },
      );
    }
  


export const getCommunicationPreferencesControllerUpdateCommunicationPreferencesMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof communicationPreferencesControllerUpdateCommunicationPreferences>>, TError,{data: CommunicationPreferenceDto[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof communicationPreferencesControllerUpdateCommunicationPreferences>>, TError,{data: CommunicationPreferenceDto[]}, TContext> => {

const mutationKey = ['communicationPreferencesControllerUpdateCommunicationPreferences'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof communicationPreferencesControllerUpdateCommunicationPreferences>>, {data: CommunicationPreferenceDto[]}> = (props) => {
          const {data} = props ?? {};

          return  communicationPreferencesControllerUpdateCommunicationPreferences(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CommunicationPreferencesControllerUpdateCommunicationPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof communicationPreferencesControllerUpdateCommunicationPreferences>>>
    export type CommunicationPreferencesControllerUpdateCommunicationPreferencesMutationBody = CommunicationPreferenceDto[]
    export type CommunicationPreferencesControllerUpdateCommunicationPreferencesMutationError = ProblemDetail

    export const useCommunicationPreferencesControllerUpdateCommunicationPreferences = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof communicationPreferencesControllerUpdateCommunicationPreferences>>, TError,{data: CommunicationPreferenceDto[]}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof communicationPreferencesControllerUpdateCommunicationPreferences>>,
        TError,
        {data: CommunicationPreferenceDto[]},
        TContext
      > => {

      const mutationOptions = getCommunicationPreferencesControllerUpdateCommunicationPreferencesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const conditionsControllerGetCondition = (
    conditionId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<ConditionDto>(
      {url: `/conditions/${conditionId}`, method: 'GET', signal
    },
      );
    }
  



export const getConditionsControllerGetConditionQueryKey = (conditionId?: string,) => {
    return [
    `/conditions/${conditionId}`
    ] as const;
    }

    
export const getConditionsControllerGetConditionQueryOptions = <TData = Awaited<ReturnType<typeof conditionsControllerGetCondition>>, TError = void>(conditionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof conditionsControllerGetCondition>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConditionsControllerGetConditionQueryKey(conditionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof conditionsControllerGetCondition>>> = ({ signal }) => conditionsControllerGetCondition(conditionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(conditionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof conditionsControllerGetCondition>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConditionsControllerGetConditionQueryResult = NonNullable<Awaited<ReturnType<typeof conditionsControllerGetCondition>>>
export type ConditionsControllerGetConditionQueryError = void


export function useConditionsControllerGetCondition<TData = Awaited<ReturnType<typeof conditionsControllerGetCondition>>, TError = void>(
 conditionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof conditionsControllerGetCondition>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof conditionsControllerGetCondition>>,
          TError,
          Awaited<ReturnType<typeof conditionsControllerGetCondition>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConditionsControllerGetCondition<TData = Awaited<ReturnType<typeof conditionsControllerGetCondition>>, TError = void>(
 conditionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof conditionsControllerGetCondition>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof conditionsControllerGetCondition>>,
          TError,
          Awaited<ReturnType<typeof conditionsControllerGetCondition>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConditionsControllerGetCondition<TData = Awaited<ReturnType<typeof conditionsControllerGetCondition>>, TError = void>(
 conditionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof conditionsControllerGetCondition>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useConditionsControllerGetCondition<TData = Awaited<ReturnType<typeof conditionsControllerGetCondition>>, TError = void>(
 conditionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof conditionsControllerGetCondition>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConditionsControllerGetConditionQueryOptions(conditionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const healthControllerCheck = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<HealthControllerCheck200>(
      {url: `/health`, method: 'GET', signal
    },
      );
    }
  



export const getHealthControllerCheckQueryKey = () => {
    return [
    `/health`
    ] as const;
    }

    
export const getHealthControllerCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthControllerCheck>>, TError = HealthControllerCheck503>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerCheck>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthControllerCheckQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerCheck>>> = ({ signal }) => healthControllerCheck(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthControllerCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthControllerCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthControllerCheck>>>
export type HealthControllerCheckQueryError = HealthControllerCheck503


export function useHealthControllerCheck<TData = Awaited<ReturnType<typeof healthControllerCheck>>, TError = HealthControllerCheck503>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerCheck>>,
          TError,
          Awaited<ReturnType<typeof healthControllerCheck>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthControllerCheck<TData = Awaited<ReturnType<typeof healthControllerCheck>>, TError = HealthControllerCheck503>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerCheck>>,
          TError,
          Awaited<ReturnType<typeof healthControllerCheck>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthControllerCheck<TData = Awaited<ReturnType<typeof healthControllerCheck>>, TError = HealthControllerCheck503>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerCheck>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHealthControllerCheck<TData = Awaited<ReturnType<typeof healthControllerCheck>>, TError = HealthControllerCheck503>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerCheck>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthControllerCheckQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const healthControllerCheckExternal = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<void>(
      {url: `/health/external`, method: 'GET', signal
    },
      );
    }
  



export const getHealthControllerCheckExternalQueryKey = () => {
    return [
    `/health/external`
    ] as const;
    }

    
export const getHealthControllerCheckExternalQueryOptions = <TData = Awaited<ReturnType<typeof healthControllerCheckExternal>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerCheckExternal>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthControllerCheckExternalQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerCheckExternal>>> = ({ signal }) => healthControllerCheckExternal(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthControllerCheckExternal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthControllerCheckExternalQueryResult = NonNullable<Awaited<ReturnType<typeof healthControllerCheckExternal>>>
export type HealthControllerCheckExternalQueryError = unknown


export function useHealthControllerCheckExternal<TData = Awaited<ReturnType<typeof healthControllerCheckExternal>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerCheckExternal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerCheckExternal>>,
          TError,
          Awaited<ReturnType<typeof healthControllerCheckExternal>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthControllerCheckExternal<TData = Awaited<ReturnType<typeof healthControllerCheckExternal>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerCheckExternal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerCheckExternal>>,
          TError,
          Awaited<ReturnType<typeof healthControllerCheckExternal>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthControllerCheckExternal<TData = Awaited<ReturnType<typeof healthControllerCheckExternal>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerCheckExternal>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHealthControllerCheckExternal<TData = Awaited<ReturnType<typeof healthControllerCheckExternal>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthControllerCheckExternal>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthControllerCheckExternalQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const inviteCodeControllerCheckInviteCode = (
    inviteCode: string,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<void>(
      {url: `/invite-code/${inviteCode}`, method: 'GET', signal
    },
      );
    }
  



export const getInviteCodeControllerCheckInviteCodeQueryKey = (inviteCode?: string,) => {
    return [
    `/invite-code/${inviteCode}`
    ] as const;
    }

    
export const getInviteCodeControllerCheckInviteCodeQueryOptions = <TData = Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>, TError = unknown>(inviteCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInviteCodeControllerCheckInviteCodeQueryKey(inviteCode);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>> = ({ signal }) => inviteCodeControllerCheckInviteCode(inviteCode, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(inviteCode), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InviteCodeControllerCheckInviteCodeQueryResult = NonNullable<Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>>
export type InviteCodeControllerCheckInviteCodeQueryError = unknown


export function useInviteCodeControllerCheckInviteCode<TData = Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>, TError = unknown>(
 inviteCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>,
          TError,
          Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInviteCodeControllerCheckInviteCode<TData = Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>, TError = unknown>(
 inviteCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>,
          TError,
          Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInviteCodeControllerCheckInviteCode<TData = Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>, TError = unknown>(
 inviteCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useInviteCodeControllerCheckInviteCode<TData = Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>, TError = unknown>(
 inviteCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inviteCodeControllerCheckInviteCode>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInviteCodeControllerCheckInviteCodeQueryOptions(inviteCode,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const meControllerGetUserInfo = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<MeResponse>(
      {url: `/me`, method: 'GET', signal
    },
      );
    }
  



export const getMeControllerGetUserInfoQueryKey = () => {
    return [
    `/me`
    ] as const;
    }

    
export const getMeControllerGetUserInfoQueryOptions = <TData = Awaited<ReturnType<typeof meControllerGetUserInfo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetUserInfo>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeControllerGetUserInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerGetUserInfo>>> = ({ signal }) => meControllerGetUserInfo(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerGetUserInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeControllerGetUserInfoQueryResult = NonNullable<Awaited<ReturnType<typeof meControllerGetUserInfo>>>
export type MeControllerGetUserInfoQueryError = unknown


export function useMeControllerGetUserInfo<TData = Awaited<ReturnType<typeof meControllerGetUserInfo>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetUserInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetUserInfo>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetUserInfo>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeControllerGetUserInfo<TData = Awaited<ReturnType<typeof meControllerGetUserInfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetUserInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetUserInfo>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetUserInfo>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeControllerGetUserInfo<TData = Awaited<ReturnType<typeof meControllerGetUserInfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetUserInfo>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMeControllerGetUserInfo<TData = Awaited<ReturnType<typeof meControllerGetUserInfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetUserInfo>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeControllerGetUserInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const meControllerGetUserFeatureFlags = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<UserFeatureFlagDto>(
      {url: `/me/feature-flags`, method: 'GET', signal
    },
      );
    }
  



export const getMeControllerGetUserFeatureFlagsQueryKey = () => {
    return [
    `/me/feature-flags`
    ] as const;
    }

    
export const getMeControllerGetUserFeatureFlagsQueryOptions = <TData = Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeControllerGetUserFeatureFlagsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>> = ({ signal }) => meControllerGetUserFeatureFlags(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeControllerGetUserFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>>
export type MeControllerGetUserFeatureFlagsQueryError = unknown


export function useMeControllerGetUserFeatureFlags<TData = Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeControllerGetUserFeatureFlags<TData = Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeControllerGetUserFeatureFlags<TData = Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMeControllerGetUserFeatureFlags<TData = Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetUserFeatureFlags>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeControllerGetUserFeatureFlagsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userProfileControllerUpdateProfile = (
    updateProfileDto: UpdateProfileDto,
 ) => {
      
      
      return customFetcher<UpdateProfileResponse>(
      {url: `/profile`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateProfileDto
    },
      );
    }
  


export const getUserProfileControllerUpdateProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userProfileControllerUpdateProfile>>, TError,{data: UpdateProfileDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userProfileControllerUpdateProfile>>, TError,{data: UpdateProfileDto}, TContext> => {

const mutationKey = ['userProfileControllerUpdateProfile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userProfileControllerUpdateProfile>>, {data: UpdateProfileDto}> = (props) => {
          const {data} = props ?? {};

          return  userProfileControllerUpdateProfile(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserProfileControllerUpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof userProfileControllerUpdateProfile>>>
    export type UserProfileControllerUpdateProfileMutationBody = UpdateProfileDto
    export type UserProfileControllerUpdateProfileMutationError = unknown

    export const useUserProfileControllerUpdateProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userProfileControllerUpdateProfile>>, TError,{data: UpdateProfileDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userProfileControllerUpdateProfile>>,
        TError,
        {data: UpdateProfileDto},
        TContext
      > => {

      const mutationOptions = getUserProfileControllerUpdateProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const resourcesControllerGetResource = (
    route: string,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<ResourceDto[]>(
      {url: `/resources/${route}`, method: 'GET', signal
    },
      );
    }
  



export const getResourcesControllerGetResourceQueryKey = (route?: string,) => {
    return [
    `/resources/${route}`
    ] as const;
    }

    
export const getResourcesControllerGetResourceQueryOptions = <TData = Awaited<ReturnType<typeof resourcesControllerGetResource>>, TError = unknown>(route: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resourcesControllerGetResource>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getResourcesControllerGetResourceQueryKey(route);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof resourcesControllerGetResource>>> = ({ signal }) => resourcesControllerGetResource(route, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(route), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resourcesControllerGetResource>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ResourcesControllerGetResourceQueryResult = NonNullable<Awaited<ReturnType<typeof resourcesControllerGetResource>>>
export type ResourcesControllerGetResourceQueryError = unknown


export function useResourcesControllerGetResource<TData = Awaited<ReturnType<typeof resourcesControllerGetResource>>, TError = unknown>(
 route: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof resourcesControllerGetResource>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof resourcesControllerGetResource>>,
          TError,
          Awaited<ReturnType<typeof resourcesControllerGetResource>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResourcesControllerGetResource<TData = Awaited<ReturnType<typeof resourcesControllerGetResource>>, TError = unknown>(
 route: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resourcesControllerGetResource>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof resourcesControllerGetResource>>,
          TError,
          Awaited<ReturnType<typeof resourcesControllerGetResource>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResourcesControllerGetResource<TData = Awaited<ReturnType<typeof resourcesControllerGetResource>>, TError = unknown>(
 route: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resourcesControllerGetResource>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useResourcesControllerGetResource<TData = Awaited<ReturnType<typeof resourcesControllerGetResource>>, TError = unknown>(
 route: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resourcesControllerGetResource>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getResourcesControllerGetResourceQueryOptions(route,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userRiskControllerGetUserRisk = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<UserRiskDto>(
      {url: `/risk`, method: 'GET', signal
    },
      );
    }
  



export const getUserRiskControllerGetUserRiskQueryKey = () => {
    return [
    `/risk`
    ] as const;
    }

    
export const getUserRiskControllerGetUserRiskQueryOptions = <TData = Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserRiskControllerGetUserRiskQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>> = ({ signal }) => userRiskControllerGetUserRisk(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserRiskControllerGetUserRiskQueryResult = NonNullable<Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>>
export type UserRiskControllerGetUserRiskQueryError = unknown


export function useUserRiskControllerGetUserRisk<TData = Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>,
          TError,
          Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserRiskControllerGetUserRisk<TData = Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>,
          TError,
          Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserRiskControllerGetUserRisk<TData = Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserRiskControllerGetUserRisk<TData = Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetUserRisk>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserRiskControllerGetUserRiskQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const riskFactorsControllerGetUserRisk = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<UserRiskFactorsPerCancerDto>(
      {url: `/risk-factors`, method: 'GET', signal
    },
      );
    }
  



export const getRiskFactorsControllerGetUserRiskQueryKey = () => {
    return [
    `/risk-factors`
    ] as const;
    }

    
export const getRiskFactorsControllerGetUserRiskQueryOptions = <TData = Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRiskFactorsControllerGetUserRiskQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>> = ({ signal }) => riskFactorsControllerGetUserRisk(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RiskFactorsControllerGetUserRiskQueryResult = NonNullable<Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>>
export type RiskFactorsControllerGetUserRiskQueryError = unknown


export function useRiskFactorsControllerGetUserRisk<TData = Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>,
          TError,
          Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRiskFactorsControllerGetUserRisk<TData = Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>,
          TError,
          Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRiskFactorsControllerGetUserRisk<TData = Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRiskFactorsControllerGetUserRisk<TData = Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskFactorsControllerGetUserRisk>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRiskFactorsControllerGetUserRiskQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const riskFactorsByCancerControllerGetUserRisk = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<UserRiskFactorsPerCancerDto>(
      {url: `/risk-factors-by-cancer`, method: 'GET', signal
    },
      );
    }
  



export const getRiskFactorsByCancerControllerGetUserRiskQueryKey = () => {
    return [
    `/risk-factors-by-cancer`
    ] as const;
    }

    
export const getRiskFactorsByCancerControllerGetUserRiskQueryOptions = <TData = Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRiskFactorsByCancerControllerGetUserRiskQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>> = ({ signal }) => riskFactorsByCancerControllerGetUserRisk(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RiskFactorsByCancerControllerGetUserRiskQueryResult = NonNullable<Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>>
export type RiskFactorsByCancerControllerGetUserRiskQueryError = unknown


export function useRiskFactorsByCancerControllerGetUserRisk<TData = Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>,
          TError,
          Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRiskFactorsByCancerControllerGetUserRisk<TData = Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>,
          TError,
          Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRiskFactorsByCancerControllerGetUserRisk<TData = Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRiskFactorsByCancerControllerGetUserRisk<TData = Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskFactorsByCancerControllerGetUserRisk>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRiskFactorsByCancerControllerGetUserRiskQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userRiskControllerGetRiskAnalysis = (
    cancerType: 'bladder' | 'brain' | 'breast' | 'cervical' | 'colon' | 'esophageal' | 'head_and_neck' | 'kidney' | 'leukemia' | 'liver' | 'lung' | 'lymphoma' | 'melanoma' | 'multiple_myeloma' | 'ovarian' | 'pancreatic' | 'prostate' | 'stomach' | 'testicular' | 'thyroid' | 'endometrial' | 'overall',
 signal?: AbortSignal
) => {
      
      
      return customFetcher<RiskAnalysisDto>(
      {url: `/risk/analysis/${cancerType}`, method: 'GET', signal
    },
      );
    }
  



export const getUserRiskControllerGetRiskAnalysisQueryKey = (cancerType?: 'bladder' | 'brain' | 'breast' | 'cervical' | 'colon' | 'esophageal' | 'head_and_neck' | 'kidney' | 'leukemia' | 'liver' | 'lung' | 'lymphoma' | 'melanoma' | 'multiple_myeloma' | 'ovarian' | 'pancreatic' | 'prostate' | 'stomach' | 'testicular' | 'thyroid' | 'endometrial' | 'overall',) => {
    return [
    `/risk/analysis/${cancerType}`
    ] as const;
    }

    
export const getUserRiskControllerGetRiskAnalysisQueryOptions = <TData = Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>, TError = unknown>(cancerType: 'bladder' | 'brain' | 'breast' | 'cervical' | 'colon' | 'esophageal' | 'head_and_neck' | 'kidney' | 'leukemia' | 'liver' | 'lung' | 'lymphoma' | 'melanoma' | 'multiple_myeloma' | 'ovarian' | 'pancreatic' | 'prostate' | 'stomach' | 'testicular' | 'thyroid' | 'endometrial' | 'overall', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserRiskControllerGetRiskAnalysisQueryKey(cancerType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>> = ({ signal }) => userRiskControllerGetRiskAnalysis(cancerType, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cancerType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserRiskControllerGetRiskAnalysisQueryResult = NonNullable<Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>>
export type UserRiskControllerGetRiskAnalysisQueryError = unknown


export function useUserRiskControllerGetRiskAnalysis<TData = Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>, TError = unknown>(
 cancerType: 'bladder' | 'brain' | 'breast' | 'cervical' | 'colon' | 'esophageal' | 'head_and_neck' | 'kidney' | 'leukemia' | 'liver' | 'lung' | 'lymphoma' | 'melanoma' | 'multiple_myeloma' | 'ovarian' | 'pancreatic' | 'prostate' | 'stomach' | 'testicular' | 'thyroid' | 'endometrial' | 'overall', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>,
          TError,
          Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserRiskControllerGetRiskAnalysis<TData = Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>, TError = unknown>(
 cancerType: 'bladder' | 'brain' | 'breast' | 'cervical' | 'colon' | 'esophageal' | 'head_and_neck' | 'kidney' | 'leukemia' | 'liver' | 'lung' | 'lymphoma' | 'melanoma' | 'multiple_myeloma' | 'ovarian' | 'pancreatic' | 'prostate' | 'stomach' | 'testicular' | 'thyroid' | 'endometrial' | 'overall', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>,
          TError,
          Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserRiskControllerGetRiskAnalysis<TData = Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>, TError = unknown>(
 cancerType: 'bladder' | 'brain' | 'breast' | 'cervical' | 'colon' | 'esophageal' | 'head_and_neck' | 'kidney' | 'leukemia' | 'liver' | 'lung' | 'lymphoma' | 'melanoma' | 'multiple_myeloma' | 'ovarian' | 'pancreatic' | 'prostate' | 'stomach' | 'testicular' | 'thyroid' | 'endometrial' | 'overall', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserRiskControllerGetRiskAnalysis<TData = Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>, TError = unknown>(
 cancerType: 'bladder' | 'brain' | 'breast' | 'cervical' | 'colon' | 'esophageal' | 'head_and_neck' | 'kidney' | 'leukemia' | 'liver' | 'lung' | 'lymphoma' | 'melanoma' | 'multiple_myeloma' | 'ovarian' | 'pancreatic' | 'prostate' | 'stomach' | 'testicular' | 'thyroid' | 'endometrial' | 'overall', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetRiskAnalysis>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserRiskControllerGetRiskAnalysisQueryOptions(cancerType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userRiskControllerGetUserRiskTrend = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<UserRiskTrendDto>(
      {url: `/risk/trend`, method: 'GET', signal
    },
      );
    }
  



export const getUserRiskControllerGetUserRiskTrendQueryKey = () => {
    return [
    `/risk/trend`
    ] as const;
    }

    
export const getUserRiskControllerGetUserRiskTrendQueryOptions = <TData = Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserRiskControllerGetUserRiskTrendQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>> = ({ signal }) => userRiskControllerGetUserRiskTrend(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserRiskControllerGetUserRiskTrendQueryResult = NonNullable<Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>>
export type UserRiskControllerGetUserRiskTrendQueryError = unknown


export function useUserRiskControllerGetUserRiskTrend<TData = Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>,
          TError,
          Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserRiskControllerGetUserRiskTrend<TData = Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>,
          TError,
          Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserRiskControllerGetUserRiskTrend<TData = Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserRiskControllerGetUserRiskTrend<TData = Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRiskControllerGetUserRiskTrend>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserRiskControllerGetUserRiskTrendQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const testingPlanControllerGetScreening = (
    screeningId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<ScreeningDto>(
      {url: `/testing-plan/screening/${screeningId}`, method: 'GET', signal
    },
      );
    }
  



export const getTestingPlanControllerGetScreeningQueryKey = (screeningId?: string,) => {
    return [
    `/testing-plan/screening/${screeningId}`
    ] as const;
    }

    
export const getTestingPlanControllerGetScreeningQueryOptions = <TData = Awaited<ReturnType<typeof testingPlanControllerGetScreening>>, TError = unknown>(screeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingPlanControllerGetScreening>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingPlanControllerGetScreeningQueryKey(screeningId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingPlanControllerGetScreening>>> = ({ signal }) => testingPlanControllerGetScreening(screeningId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(screeningId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingPlanControllerGetScreening>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingPlanControllerGetScreeningQueryResult = NonNullable<Awaited<ReturnType<typeof testingPlanControllerGetScreening>>>
export type TestingPlanControllerGetScreeningQueryError = unknown


export function useTestingPlanControllerGetScreening<TData = Awaited<ReturnType<typeof testingPlanControllerGetScreening>>, TError = unknown>(
 screeningId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingPlanControllerGetScreening>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingPlanControllerGetScreening>>,
          TError,
          Awaited<ReturnType<typeof testingPlanControllerGetScreening>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingPlanControllerGetScreening<TData = Awaited<ReturnType<typeof testingPlanControllerGetScreening>>, TError = unknown>(
 screeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingPlanControllerGetScreening>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingPlanControllerGetScreening>>,
          TError,
          Awaited<ReturnType<typeof testingPlanControllerGetScreening>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingPlanControllerGetScreening<TData = Awaited<ReturnType<typeof testingPlanControllerGetScreening>>, TError = unknown>(
 screeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingPlanControllerGetScreening>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingPlanControllerGetScreening<TData = Awaited<ReturnType<typeof testingPlanControllerGetScreening>>, TError = unknown>(
 screeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingPlanControllerGetScreening>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingPlanControllerGetScreeningQueryOptions(screeningId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const testingPlanControllerGetUserScreenings = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<UserScreeningsDto>(
      {url: `/testing-plan/screenings`, method: 'GET', signal
    },
      );
    }
  



export const getTestingPlanControllerGetUserScreeningsQueryKey = () => {
    return [
    `/testing-plan/screenings`
    ] as const;
    }

    
export const getTestingPlanControllerGetUserScreeningsQueryOptions = <TData = Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTestingPlanControllerGetUserScreeningsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>> = ({ signal }) => testingPlanControllerGetUserScreenings(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TestingPlanControllerGetUserScreeningsQueryResult = NonNullable<Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>>
export type TestingPlanControllerGetUserScreeningsQueryError = unknown


export function useTestingPlanControllerGetUserScreenings<TData = Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>,
          TError,
          Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingPlanControllerGetUserScreenings<TData = Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>,
          TError,
          Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTestingPlanControllerGetUserScreenings<TData = Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTestingPlanControllerGetUserScreenings<TData = Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof testingPlanControllerGetUserScreenings>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTestingPlanControllerGetUserScreeningsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const testingPlanControllerCompleteTestSuggestion = (
    id: string,
 ) => {
      
      
      return customFetcher<void>(
      {url: `/testing-plan/test-suggestion/${id}/complete`, method: 'PATCH'
    },
      );
    }
  


export const getTestingPlanControllerCompleteTestSuggestionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingPlanControllerCompleteTestSuggestion>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof testingPlanControllerCompleteTestSuggestion>>, TError,{id: string}, TContext> => {

const mutationKey = ['testingPlanControllerCompleteTestSuggestion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingPlanControllerCompleteTestSuggestion>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  testingPlanControllerCompleteTestSuggestion(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestingPlanControllerCompleteTestSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof testingPlanControllerCompleteTestSuggestion>>>
    
    export type TestingPlanControllerCompleteTestSuggestionMutationError = unknown

    export const useTestingPlanControllerCompleteTestSuggestion = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingPlanControllerCompleteTestSuggestion>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingPlanControllerCompleteTestSuggestion>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getTestingPlanControllerCompleteTestSuggestionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const testingPlanControllerUpdateTestSuggestionTargetDate = (
    id: string,
 ) => {
      
      
      return customFetcher<void>(
      {url: `/testing-plan/test-suggestion/${id}/target-date`, method: 'PATCH'
    },
      );
    }
  


export const getTestingPlanControllerUpdateTestSuggestionTargetDateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingPlanControllerUpdateTestSuggestionTargetDate>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof testingPlanControllerUpdateTestSuggestionTargetDate>>, TError,{id: string}, TContext> => {

const mutationKey = ['testingPlanControllerUpdateTestSuggestionTargetDate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testingPlanControllerUpdateTestSuggestionTargetDate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  testingPlanControllerUpdateTestSuggestionTargetDate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestingPlanControllerUpdateTestSuggestionTargetDateMutationResult = NonNullable<Awaited<ReturnType<typeof testingPlanControllerUpdateTestSuggestionTargetDate>>>
    
    export type TestingPlanControllerUpdateTestSuggestionTargetDateMutationError = unknown

    export const useTestingPlanControllerUpdateTestSuggestionTargetDate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testingPlanControllerUpdateTestSuggestionTargetDate>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testingPlanControllerUpdateTestSuggestionTargetDate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getTestingPlanControllerUpdateTestSuggestionTargetDateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const userLevelControllerUpdateUserLevel = (
    updateUserLevelDto: UpdateUserLevelDto,
 ) => {
      
      
      return customFetcher<SuccessResponse>(
      {url: `/user-level`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateUserLevelDto
    },
      );
    }
  


export const getUserLevelControllerUpdateUserLevelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userLevelControllerUpdateUserLevel>>, TError,{data: UpdateUserLevelDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userLevelControllerUpdateUserLevel>>, TError,{data: UpdateUserLevelDto}, TContext> => {

const mutationKey = ['userLevelControllerUpdateUserLevel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userLevelControllerUpdateUserLevel>>, {data: UpdateUserLevelDto}> = (props) => {
          const {data} = props ?? {};

          return  userLevelControllerUpdateUserLevel(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserLevelControllerUpdateUserLevelMutationResult = NonNullable<Awaited<ReturnType<typeof userLevelControllerUpdateUserLevel>>>
    export type UserLevelControllerUpdateUserLevelMutationBody = UpdateUserLevelDto
    export type UserLevelControllerUpdateUserLevelMutationError = unknown

    export const useUserLevelControllerUpdateUserLevel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userLevelControllerUpdateUserLevel>>, TError,{data: UpdateUserLevelDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userLevelControllerUpdateUserLevel>>,
        TError,
        {data: UpdateUserLevelDto},
        TContext
      > => {

      const mutationOptions = getUserLevelControllerUpdateUserLevelMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const userAssessmentQuestionnaireControllerGetUserQuestionnaire = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<UserQuestionnaireDto>(
      {url: `/user-questionnaires/assessment/current`, method: 'GET', signal
    },
      );
    }
  



export const getUserAssessmentQuestionnaireControllerGetUserQuestionnaireQueryKey = () => {
    return [
    `/user-questionnaires/assessment/current`
    ] as const;
    }

    
export const getUserAssessmentQuestionnaireControllerGetUserQuestionnaireQueryOptions = <TData = Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserAssessmentQuestionnaireControllerGetUserQuestionnaireQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>> = ({ signal }) => userAssessmentQuestionnaireControllerGetUserQuestionnaire(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserAssessmentQuestionnaireControllerGetUserQuestionnaireQueryResult = NonNullable<Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>>
export type UserAssessmentQuestionnaireControllerGetUserQuestionnaireQueryError = unknown


export function useUserAssessmentQuestionnaireControllerGetUserQuestionnaire<TData = Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserAssessmentQuestionnaireControllerGetUserQuestionnaire<TData = Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserAssessmentQuestionnaireControllerGetUserQuestionnaire<TData = Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserAssessmentQuestionnaireControllerGetUserQuestionnaire<TData = Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerGetUserQuestionnaire>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserAssessmentQuestionnaireControllerGetUserQuestionnaireQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userAssessmentQuestionnaireControllerPutQuestionAnswer = (
    surveyItemId: string,
    isIntervention: boolean,
    userAssessmentQuestionnaireControllerPutQuestionAnswerBody: UserAssessmentQuestionnaireControllerPutQuestionAnswerBody,
 ) => {
      
      
      return customFetcher<UserQuestionnaireDto>(
      {url: `/user-questionnaires/assessment/current/survey-item/${surveyItemId}/${isIntervention}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userAssessmentQuestionnaireControllerPutQuestionAnswerBody
    },
      );
    }
  


export const getUserAssessmentQuestionnaireControllerPutQuestionAnswerMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerPutQuestionAnswer>>, TError,{surveyItemId: string;isIntervention: boolean;data: UserAssessmentQuestionnaireControllerPutQuestionAnswerBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerPutQuestionAnswer>>, TError,{surveyItemId: string;isIntervention: boolean;data: UserAssessmentQuestionnaireControllerPutQuestionAnswerBody}, TContext> => {

const mutationKey = ['userAssessmentQuestionnaireControllerPutQuestionAnswer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerPutQuestionAnswer>>, {surveyItemId: string;isIntervention: boolean;data: UserAssessmentQuestionnaireControllerPutQuestionAnswerBody}> = (props) => {
          const {surveyItemId,isIntervention,data} = props ?? {};

          return  userAssessmentQuestionnaireControllerPutQuestionAnswer(surveyItemId,isIntervention,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserAssessmentQuestionnaireControllerPutQuestionAnswerMutationResult = NonNullable<Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerPutQuestionAnswer>>>
    export type UserAssessmentQuestionnaireControllerPutQuestionAnswerMutationBody = UserAssessmentQuestionnaireControllerPutQuestionAnswerBody
    export type UserAssessmentQuestionnaireControllerPutQuestionAnswerMutationError = ProblemDetail

    export const useUserAssessmentQuestionnaireControllerPutQuestionAnswer = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerPutQuestionAnswer>>, TError,{surveyItemId: string;isIntervention: boolean;data: UserAssessmentQuestionnaireControllerPutQuestionAnswerBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userAssessmentQuestionnaireControllerPutQuestionAnswer>>,
        TError,
        {surveyItemId: string;isIntervention: boolean;data: UserAssessmentQuestionnaireControllerPutQuestionAnswerBody},
        TContext
      > => {

      const mutationOptions = getUserAssessmentQuestionnaireControllerPutQuestionAnswerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const userScreeningQuestionnaireControllerPutSurveyItemAnswer = (
    answerScreeningId: string,
    surveyItemId: string,
    userScreeningQuestionnaireControllerPutSurveyItemAnswerBody: UserScreeningQuestionnaireControllerPutSurveyItemAnswerBody,
 ) => {
      
      
      return customFetcher<UserQuestionnaireDto>(
      {url: `/user-questionnaires/screening/current/${answerScreeningId}/survey-item/${surveyItemId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userScreeningQuestionnaireControllerPutSurveyItemAnswerBody
    },
      );
    }
  


export const getUserScreeningQuestionnaireControllerPutSurveyItemAnswerMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerPutSurveyItemAnswer>>, TError,{answerScreeningId: string;surveyItemId: string;data: UserScreeningQuestionnaireControllerPutSurveyItemAnswerBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerPutSurveyItemAnswer>>, TError,{answerScreeningId: string;surveyItemId: string;data: UserScreeningQuestionnaireControllerPutSurveyItemAnswerBody}, TContext> => {

const mutationKey = ['userScreeningQuestionnaireControllerPutSurveyItemAnswer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerPutSurveyItemAnswer>>, {answerScreeningId: string;surveyItemId: string;data: UserScreeningQuestionnaireControllerPutSurveyItemAnswerBody}> = (props) => {
          const {answerScreeningId,surveyItemId,data} = props ?? {};

          return  userScreeningQuestionnaireControllerPutSurveyItemAnswer(answerScreeningId,surveyItemId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserScreeningQuestionnaireControllerPutSurveyItemAnswerMutationResult = NonNullable<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerPutSurveyItemAnswer>>>
    export type UserScreeningQuestionnaireControllerPutSurveyItemAnswerMutationBody = UserScreeningQuestionnaireControllerPutSurveyItemAnswerBody
    export type UserScreeningQuestionnaireControllerPutSurveyItemAnswerMutationError = ProblemDetail

    export const useUserScreeningQuestionnaireControllerPutSurveyItemAnswer = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerPutSurveyItemAnswer>>, TError,{answerScreeningId: string;surveyItemId: string;data: UserScreeningQuestionnaireControllerPutSurveyItemAnswerBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userScreeningQuestionnaireControllerPutSurveyItemAnswer>>,
        TError,
        {answerScreeningId: string;surveyItemId: string;data: UserScreeningQuestionnaireControllerPutSurveyItemAnswerBody},
        TContext
      > => {

      const mutationOptions = getUserScreeningQuestionnaireControllerPutSurveyItemAnswerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const userScreeningQuestionnaireControllerCreateUserQuestionnaire = (
    screeningId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<UserQuestionnaireDto>(
      {url: `/user-questionnaires/screening/current/${screeningId}`, method: 'GET', signal
    },
      );
    }
  



export const getUserScreeningQuestionnaireControllerCreateUserQuestionnaireQueryKey = (screeningId?: string,) => {
    return [
    `/user-questionnaires/screening/current/${screeningId}`
    ] as const;
    }

    
export const getUserScreeningQuestionnaireControllerCreateUserQuestionnaireQueryOptions = <TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>, TError = unknown>(screeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserScreeningQuestionnaireControllerCreateUserQuestionnaireQueryKey(screeningId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>> = ({ signal }) => userScreeningQuestionnaireControllerCreateUserQuestionnaire(screeningId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(screeningId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserScreeningQuestionnaireControllerCreateUserQuestionnaireQueryResult = NonNullable<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>>
export type UserScreeningQuestionnaireControllerCreateUserQuestionnaireQueryError = unknown


export function useUserScreeningQuestionnaireControllerCreateUserQuestionnaire<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>, TError = unknown>(
 screeningId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserScreeningQuestionnaireControllerCreateUserQuestionnaire<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>, TError = unknown>(
 screeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserScreeningQuestionnaireControllerCreateUserQuestionnaire<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>, TError = unknown>(
 screeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserScreeningQuestionnaireControllerCreateUserQuestionnaire<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>, TError = unknown>(
 screeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerCreateUserQuestionnaire>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserScreeningQuestionnaireControllerCreateUserQuestionnaireQueryOptions(screeningId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userScreeningQuestionnaireControllerGetScreeningAnswersHistory = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<ScreeningAnswerDto[]>(
      {url: `/user-questionnaires/screening/history`, method: 'GET', signal
    },
      );
    }
  



export const getUserScreeningQuestionnaireControllerGetScreeningAnswersHistoryQueryKey = () => {
    return [
    `/user-questionnaires/screening/history`
    ] as const;
    }

    
export const getUserScreeningQuestionnaireControllerGetScreeningAnswersHistoryQueryOptions = <TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>, TError = ProblemDetail>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserScreeningQuestionnaireControllerGetScreeningAnswersHistoryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>> = ({ signal }) => userScreeningQuestionnaireControllerGetScreeningAnswersHistory(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserScreeningQuestionnaireControllerGetScreeningAnswersHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>>
export type UserScreeningQuestionnaireControllerGetScreeningAnswersHistoryQueryError = ProblemDetail


export function useUserScreeningQuestionnaireControllerGetScreeningAnswersHistory<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>, TError = ProblemDetail>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>,
          TError,
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserScreeningQuestionnaireControllerGetScreeningAnswersHistory<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>,
          TError,
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserScreeningQuestionnaireControllerGetScreeningAnswersHistory<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserScreeningQuestionnaireControllerGetScreeningAnswersHistory<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserScreeningQuestionnaireControllerGetScreeningAnswersHistoryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType = (
    screeningTypeId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<ScreeningAnswerDto[]>(
      {url: `/user-questionnaires/screening/history/${screeningTypeId}`, method: 'GET', signal
    },
      );
    }
  



export const getUserScreeningQuestionnaireControllerGetScreeningAnswersHistoryByTypeQueryKey = (screeningTypeId?: string,) => {
    return [
    `/user-questionnaires/screening/history/${screeningTypeId}`
    ] as const;
    }

    
export const getUserScreeningQuestionnaireControllerGetScreeningAnswersHistoryByTypeQueryOptions = <TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>, TError = ProblemDetail>(screeningTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserScreeningQuestionnaireControllerGetScreeningAnswersHistoryByTypeQueryKey(screeningTypeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>> = ({ signal }) => userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType(screeningTypeId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(screeningTypeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserScreeningQuestionnaireControllerGetScreeningAnswersHistoryByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>>
export type UserScreeningQuestionnaireControllerGetScreeningAnswersHistoryByTypeQueryError = ProblemDetail


export function useUserScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>, TError = ProblemDetail>(
 screeningTypeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>,
          TError,
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>, TError = ProblemDetail>(
 screeningTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>,
          TError,
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>, TError = ProblemDetail>(
 screeningTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>, TError = ProblemDetail>(
 screeningTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningAnswersHistoryByType>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserScreeningQuestionnaireControllerGetScreeningAnswersHistoryByTypeQueryOptions(screeningTypeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults = (
    answerScreeningId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<UserQuestionnaireDto>(
      {url: `/user-questionnaires/screening/results/${answerScreeningId}`, method: 'GET', signal
    },
      );
    }
  



export const getUserScreeningQuestionnaireControllerGetScreeningQuestionnaireResultsQueryKey = (answerScreeningId?: string,) => {
    return [
    `/user-questionnaires/screening/results/${answerScreeningId}`
    ] as const;
    }

    
export const getUserScreeningQuestionnaireControllerGetScreeningQuestionnaireResultsQueryOptions = <TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>, TError = unknown>(answerScreeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserScreeningQuestionnaireControllerGetScreeningQuestionnaireResultsQueryKey(answerScreeningId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>> = ({ signal }) => userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults(answerScreeningId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(answerScreeningId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserScreeningQuestionnaireControllerGetScreeningQuestionnaireResultsQueryResult = NonNullable<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>>
export type UserScreeningQuestionnaireControllerGetScreeningQuestionnaireResultsQueryError = unknown


export function useUserScreeningQuestionnaireControllerGetScreeningQuestionnaireResults<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>, TError = unknown>(
 answerScreeningId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>,
          TError,
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserScreeningQuestionnaireControllerGetScreeningQuestionnaireResults<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>, TError = unknown>(
 answerScreeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>,
          TError,
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserScreeningQuestionnaireControllerGetScreeningQuestionnaireResults<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>, TError = unknown>(
 answerScreeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserScreeningQuestionnaireControllerGetScreeningQuestionnaireResults<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>, TError = unknown>(
 answerScreeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetScreeningQuestionnaireResults>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserScreeningQuestionnaireControllerGetScreeningQuestionnaireResultsQueryOptions(answerScreeningId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userScreeningQuestionnaireControllerGetUserQuestionnaire = (
    answerScreeningId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<UserQuestionnaireDto>(
      {url: `/user-questionnaires/screening/${answerScreeningId}`, method: 'GET', signal
    },
      );
    }
  



export const getUserScreeningQuestionnaireControllerGetUserQuestionnaireQueryKey = (answerScreeningId?: string,) => {
    return [
    `/user-questionnaires/screening/${answerScreeningId}`
    ] as const;
    }

    
export const getUserScreeningQuestionnaireControllerGetUserQuestionnaireQueryOptions = <TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>, TError = unknown>(answerScreeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserScreeningQuestionnaireControllerGetUserQuestionnaireQueryKey(answerScreeningId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>> = ({ signal }) => userScreeningQuestionnaireControllerGetUserQuestionnaire(answerScreeningId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(answerScreeningId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserScreeningQuestionnaireControllerGetUserQuestionnaireQueryResult = NonNullable<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>>
export type UserScreeningQuestionnaireControllerGetUserQuestionnaireQueryError = unknown


export function useUserScreeningQuestionnaireControllerGetUserQuestionnaire<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>, TError = unknown>(
 answerScreeningId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserScreeningQuestionnaireControllerGetUserQuestionnaire<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>, TError = unknown>(
 answerScreeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserScreeningQuestionnaireControllerGetUserQuestionnaire<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>, TError = unknown>(
 answerScreeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserScreeningQuestionnaireControllerGetUserQuestionnaire<TData = Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>, TError = unknown>(
 answerScreeningId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userScreeningQuestionnaireControllerGetUserQuestionnaire>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserScreeningQuestionnaireControllerGetUserQuestionnaireQueryOptions(answerScreeningId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userControllerGetProcessingStatus = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<RiskProcessingStatusResponseDto>(
      {url: `/user/get-processing-status`, method: 'GET', signal
    },
      );
    }
  



export const getUserControllerGetProcessingStatusQueryKey = () => {
    return [
    `/user/get-processing-status`
    ] as const;
    }

    
export const getUserControllerGetProcessingStatusQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetProcessingStatus>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetProcessingStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetProcessingStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetProcessingStatus>>> = ({ signal }) => userControllerGetProcessingStatus(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetProcessingStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetProcessingStatusQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetProcessingStatus>>>
export type UserControllerGetProcessingStatusQueryError = unknown


export function useUserControllerGetProcessingStatus<TData = Awaited<ReturnType<typeof userControllerGetProcessingStatus>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetProcessingStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetProcessingStatus>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetProcessingStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetProcessingStatus<TData = Awaited<ReturnType<typeof userControllerGetProcessingStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetProcessingStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetProcessingStatus>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetProcessingStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetProcessingStatus<TData = Awaited<ReturnType<typeof userControllerGetProcessingStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetProcessingStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerGetProcessingStatus<TData = Awaited<ReturnType<typeof userControllerGetProcessingStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetProcessingStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetProcessingStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userControllerTriggerPotentialReprocessing = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<RiskProcessingStatusResponseDto>(
      {url: `/user/trigger-potential-risk-reprocessing`, method: 'POST', signal
    },
      );
    }
  


export const getUserControllerTriggerPotentialReprocessingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerTriggerPotentialReprocessing>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userControllerTriggerPotentialReprocessing>>, TError,void, TContext> => {

const mutationKey = ['userControllerTriggerPotentialReprocessing'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerTriggerPotentialReprocessing>>, void> = () => {
          

          return  userControllerTriggerPotentialReprocessing()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserControllerTriggerPotentialReprocessingMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerTriggerPotentialReprocessing>>>
    
    export type UserControllerTriggerPotentialReprocessingMutationError = unknown

    export const useUserControllerTriggerPotentialReprocessing = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerTriggerPotentialReprocessing>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userControllerTriggerPotentialReprocessing>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getUserControllerTriggerPotentialReprocessingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const userControllerTriggerReprocessing = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<RiskProcessingStatusResponseDto>(
      {url: `/user/trigger-risk-reprocessing`, method: 'POST', signal
    },
      );
    }
  


export const getUserControllerTriggerReprocessingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerTriggerReprocessing>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userControllerTriggerReprocessing>>, TError,void, TContext> => {

const mutationKey = ['userControllerTriggerReprocessing'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerTriggerReprocessing>>, void> = () => {
          

          return  userControllerTriggerReprocessing()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserControllerTriggerReprocessingMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerTriggerReprocessing>>>
    
    export type UserControllerTriggerReprocessingMutationError = unknown

    export const useUserControllerTriggerReprocessing = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerTriggerReprocessing>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userControllerTriggerReprocessing>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getUserControllerTriggerReprocessingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const stripeWebhookControllerStripeWebhook = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<void>(
      {url: `/webhook/stripe`, method: 'POST', signal
    },
      );
    }
  


export const getStripeWebhookControllerStripeWebhookMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stripeWebhookControllerStripeWebhook>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof stripeWebhookControllerStripeWebhook>>, TError,void, TContext> => {

const mutationKey = ['stripeWebhookControllerStripeWebhook'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stripeWebhookControllerStripeWebhook>>, void> = () => {
          

          return  stripeWebhookControllerStripeWebhook()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StripeWebhookControllerStripeWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof stripeWebhookControllerStripeWebhook>>>
    
    export type StripeWebhookControllerStripeWebhookMutationError = unknown

    export const useStripeWebhookControllerStripeWebhook = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stripeWebhookControllerStripeWebhook>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stripeWebhookControllerStripeWebhook>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getStripeWebhookControllerStripeWebhookMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    